/* Mapping Channel icon  */
export const channelIconMapper = channelId => {
    const channelIcons = {
        1: 'internet',
        2: 'movel',
        3: 'chat',
        5: 'ussd'
    }

    return channelIcons[channelId]
}
